/**
 * Country / region options for signup (and related forms).
 * Keep names stable — stored on users.country.
 */

export const COUNTRY_OPTIONS: string[] = [
  // Middle East & North Africa
  "Saudi Arabia",
  "United Arab Emirates",
  "Qatar",
  "Bahrain",
  "Kuwait",
  "Oman",
  "Jordan",
  "Egypt",
  "Lebanon",
  "Palestine",
  "Iraq",
  "Morocco",
  "Tunisia",
  // Europe
  "United Kingdom",
  "Germany",
  "Netherlands",
  "France",
  "Ireland",
  "Sweden",
  "Switzerland",
  "Spain",
  "Portugal",
  "Poland",
  "Italy",
  "Turkey",
  // Americas
  "United States",
  "Canada",
  "Mexico",
  "Brazil",
  // Asia & Oceania
  "Singapore",
  "Hong Kong",
  "Japan",
  "South Korea",
  "India",
  "Pakistan",
  "Australia",
  "New Zealand",
  // Africa
  "Kenya",
  "Nigeria",
  "South Africa",
  "Ghana",
];

export function isKnownCountry(value: string | null | undefined): boolean {
  const v = value?.trim();
  if (!v) return false;
  return COUNTRY_OPTIONS.some((c) => c.toLowerCase() === v.toLowerCase());
}

export function canonicalCountry(value: string): string | null {
  const v = value.trim().toLowerCase();
  return COUNTRY_OPTIONS.find((c) => c.toLowerCase() === v) ?? null;
}
